import React from "react";
import { IPagination, UtcTimePopover } from "../screenshots/screenshots.component";
import { DwsimProDialogType, LogicalOperator, SessionResponseModel, UserTagResponseModel } from "../../swagger-clients/s365-admin-panel-clients.service";
import { addDays } from "../../utilities/date.utilities";
import SubHeader from "../../layout/components/sub-header/sub-header.component";
import ContentWrapper from "../../layout/components/content-wrapper/content-wrapper.component";
import { Card, Dropdown, OverlayTrigger } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import DatePicker from "react-datepicker";
import { UserSlimDisplay } from "../../components/user-slim-display/user-slim-display";
import { DateTimeDisplayUTC } from "../../components/date-time-display/date-time-display-utc.component";
import { getSessionsClient, getUserTagsClient } from "../../services/api-clients.service";
import { ShowErrorFromResponse } from "../../utilities/response-processor";
import { Link, useHistory } from "react-router-dom";
import { DateTimeDisplay } from "../../components/date-time-display/date-time-display.component";
import { getTextBasedOnFeedbackScore } from "../feedbacks/feedbacks.component";
import { DwsimProDialogTypeDisplay } from "./dwsim-pro-dialog-type-display";
import { DwsimProDialogTypeFilter } from "./dwsim-pro-dialog-type-filter";
import { UserTagFilter } from "../../components/user-tag-filter/user-tag-filter.component";
import { _copyAndSort } from "../../utilities/array.helpers";
import SystemUserTagCodes from "../users/users.shared";

type VmSessionsPageProps = {

}

const getTodayDate = () => {
    let dateNow = new Date();
    dateNow.setHours(0);
    dateNow.setMinutes(0);
    dateNow.setSeconds(0);
    dateNow.setMilliseconds(0);
    return dateNow;
}

const getDefaultStartDate = () => {

    return addDays(getTodayDate(), -30);
}


const getDefaultEndDate = () => {
    let tomorrow = addDays(new Date(), 1);
    tomorrow.setHours(0);
    tomorrow.setMinutes(0);
    tomorrow.setSeconds(0);
    tomorrow.setMilliseconds(0);
    return tomorrow;

}

export const VmSessionsPage: React.FC<VmSessionsPageProps> = (props) => {
    const [sessions, setSessions] = React.useState<SessionResponseModel[]>([]);
    const [pagination, setPagination] = React.useState<IPagination>({
        currentPage: 1,
        recordsPerPage: 20,
        totalRecords: 0
    });
    const [userId, setUserId] = React.useState<number>();
    const [username, setUsername] = React.useState<string>();
    const [fromDate, setFromDate] = React.useState<Date>(getDefaultStartDate());
    const [toDate, setToDate] = React.useState<Date>(getDefaultEndDate());
    const [includeDialogTypes, setIncludeDialogTypes] = React.useState<DwsimProDialogType[]>([]);
    const [includeUserTags, setIncludeUsersTags] = React.useState<number[]>([]);
    const [includeOperator, setIncludeOperator] = React.useState<LogicalOperator>(LogicalOperator.And);
    const [excludeUserTags, setExcludeUsersTags] = React.useState<number[]>([]);
    const [excludeOperator, setExcludeOperator] = React.useState<LogicalOperator>(LogicalOperator.Or);
    const [orderBy, setOrderBy] = React.useState<string>("StartedAtUtc");
    const [orderByDescending, setOrderByDescending] = React.useState<boolean>(true);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [defaultUserTagsSet, setDefaultUserTagsSet] = React.useState<boolean>(false);
    const routerHistory = useHistory();


    React.useEffect(() => {
        setDefaultUserTags();
    }, []);

    React.useEffect(() => {
        if (defaultUserTagsSet) {
            getSessions();
        }

    }, [pagination.currentPage, pagination.recordsPerPage, orderBy, orderByDescending, defaultUserTagsSet]);

    const setDefaultUserTags = async () => {
        const allUserTags = await getAllUserTags();
        const testUserTag = allUserTags.find(x => x.code == SystemUserTagCodes.TEST_USER);
        let includeTags: number[] = [];
        const companyUserTag = allUserTags.find(x => x.code == SystemUserTagCodes.COMPANY);
        if (!!companyUserTag) {
            includeTags.push(companyUserTag.id);
        }
        let excludeTags: number[] = !!testUserTag ? [testUserTag.id] : [];
        const consumerUserTag = allUserTags.find(x => x.code == SystemUserTagCodes.CONSUMER);
        if (!!consumerUserTag) {
            excludeTags.push(consumerUserTag.id);
        }
        setIncludeUsersTags(includeTags);
        setExcludeUsersTags(excludeTags);
        setDefaultUserTagsSet(true);
    }

    const getAllUserTags = async () => {
        try {
            const client = getUserTagsClient();
            const userTagsResp = await client.getUserTags(null,null, undefined, 0, 10000);
            const sortedMappedOptions = _copyAndSort<UserTagResponseModel>(userTagsResp.items, "name", false);
            return sortedMappedOptions;

        } catch (error) {
            console.log("An error occurred while loading user tags", error);
        }

    }
    const getSessions = async () => {
        try {
            setSessions([]);
            setIsLoading(true);

            const { recordsPerPage, currentPage } = pagination;
            const client = getSessionsClient();
            const startDateUtc = fromDate ? new Date(Date.UTC(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds())) : null;
            const endDateUtc = toDate ? new Date(Date.UTC(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), toDate.getHours(), toDate.getMinutes(), toDate.getSeconds())) : undefined;
            const sessionsResponse = await client.getSessions(userId, username, startDateUtc, endDateUtc,
                includeUserTags, includeOperator, excludeUserTags, excludeOperator,
                includeDialogTypes, orderBy, orderByDescending, (currentPage - 1) * recordsPerPage, recordsPerPage);
            setSessions(sessionsResponse?.items ?? []);
            setPagination(s => ({ ...s, totalRecords: sessionsResponse?.totalRecords ?? 0 }));
        } catch (error) {
            ShowErrorFromResponse(error, "An error ocurred while getting sessions.");
        } finally {
            setIsLoading(false);
        }
    }

    const onTodayClick = () => {
        setFromDate(getTodayDate());
        setToDate(getDefaultEndDate());

    }
    const onLast7DaysClick = () => {
        const startDate = addDays(getTodayDate(), -7);
        setFromDate(startDate);
        setToDate(getDefaultEndDate());

    }
    const onLast30DaysClick = () => {
        const startDate = addDays(getTodayDate(), -30);
        setFromDate(startDate);
        setToDate(getDefaultEndDate());

    }

    const onLastMonthClick = () => {
        const dateNow = new Date();
        const firstInMonth = new Date(dateNow.getFullYear(), dateNow.getMonth(), 1, 0, 0, 0);
        let firstInNextMonth = new Date(dateNow.getFullYear(), dateNow.getMonth(), 1, 0, 0, 0);
        firstInNextMonth.setMonth(firstInMonth.getMonth() + 1);
        const lastDayOfMonth = addDays(firstInNextMonth, -1);
        setFromDate(firstInMonth);
        setToDate(lastDayOfMonth);

    }

    const onLastYearClick = () => {
        const dateNow = new Date();
        const januaryFirst = new Date(dateNow.getFullYear(), 0, 1, 0, 0, 0);
        setFromDate(januaryFirst);
        setToDate(getDefaultEndDate());

    }

    const onAddDayClick = (numberOfDays: number) => {

        const newDate = addDays(fromDate ?? new Date(), numberOfDays);
        setFromDate(newDate);
    }
    const onAddMonthClick = (numberOfMonths: number) => {
        let newDate = !!fromDate ? new Date(fromDate) : new Date();
        newDate.setMonth(newDate.getMonth() + numberOfMonths);
        setFromDate(newDate);
    }
    const resetForm = () => {
        setUserId(undefined);
        setUsername(undefined);
        setFromDate(getDefaultStartDate());
        setToDate(getDefaultEndDate());
        setOrderBy("StartedAtUtc");
        setOrderByDescending(true);
        setIncludeUsersTags([]);
        setExcludeUsersTags([]);
        setIncludeOperator(LogicalOperator.And);
        setExcludeOperator(LogicalOperator.Or);
    }

    const onColumnClick = (column: string) => {
        if (orderBy == column) {
            setOrderByDescending(!orderByDescending);
        } else {
            setOrderBy(column);
            setOrderByDescending(true);
        }
    }

    const getSortValue = (columnName: string) => {
        if (orderBy == columnName) {
            if (orderByDescending) {
                return "desc";
            } else {
                return "asc";
            }
        }
        return undefined;
    }
    const getScreenshotsLink = (session: SessionResponseModel) => {
        const userQuery = !!session.userId ? `userId=${session.userId}` : `username=${session.windowsUsername}`;
        let toDate = new Date(session.endedAtUtc.getTime() + 1000);
        const url = `${window.location.origin}/screenshots?${userQuery}&fromDate=${session.startedAtUtc.toISOString()}&toDate=${toDate.toISOString()}`;
        return url;
    }
    const getGraylogLink = (session: SessionResponseModel) => {
        let graylogUrl = `https://log.cc-api.com/search?&rangetype=relative&relative=0`;   
        const vmSessionId = !!session.windowsSessionId ? encodeURIComponent(`vm_session_id:${session.windowsSessionId.replaceAll('-', '\\-')}`) : undefined;
        if (!!vmSessionId) {
            graylogUrl = `${graylogUrl}&q=${vmSessionId}`;
        }
        return graylogUrl;

    }


    const { totalRecords, currentPage, recordsPerPage } = pagination;
    const totalPages = Math.ceil(totalRecords / recordsPerPage);

    return <div> <SubHeader key="sub-header" title="VM Sessions" leftItems={[]} rightItems={[]} />
        <ContentWrapper key="content-wrapper" className="pl-4 pr-4">
            <Card className='mb-4' style={{ marginRight: "auto", marginLeft: "auto", width: "100%" }}>
                <div className="pt-3 pl-3 pr-3 mr-3 d-flex justify-content-between">
                    <form onSubmit={(ev) => { ev.preventDefault(); if (currentPage !== 1) { setPagination(s => ({ ...s, currentPage: 1 })); } else { getSessions(); } }} action="">
                        <div className="form-row align-items-center">
                            <div className="col-auto" style={{ minWidth: "330px" }}>
                                <input type="text"
                                    name="username"
                                    value={username ||""}
                                    className="form-control mb-2"
                                    onChange={e => setUsername(e.target.value)}
                                    placeholder="Display name or Username" />
                            </div>

                            <div className="input-group mr-2 mb-2" style={{ width: '380px' }}>
                                <span className="input-group-text"><i className="far fa-calendar-alt"></i></span>
                                <div className="input-group__datepicker-wrapper">
                                    <DatePicker
                                        id="fromDate"
                                        className="form-control"
                                        selected={fromDate}
                                        onChange={(date: Date) => {
                                            if (!date) {
                                                setFromDate(getDefaultStartDate());
                                            } else
                                                setFromDate(new Date(Date.parse(date != null ? date.toString() : "")));
                                        }}
                                        showTimeSelect
                                        maxDate={toDate}
                                        dateFormat="dd-MM-yyyy HH:mm"
                                        timeFormat="HH:mm" />
                                </div>
                                <span className="input-group-text">-</span>

                                <div className="input-group__datepicker-wrapper">
                                    <DatePicker
                                        id="toDate"
                                        className="form-control"
                                        selected={toDate}
                                        onChange={(date: Date) => {
                                            if (!date) {
                                                setToDate(getDefaultEndDate());
                                            } else
                                                setToDate(new Date(Date.parse(date != null ? date.toString() : "")))
                                        }}
                                        showTimeSelect
                                        maxDate={new Date()}
                                        dateFormat="dd-MM-yyyy HH:mm"
                                        timeFormat="HH:mm" />
                                </div>
                                <Dropdown>
                                    <Dropdown.Toggle variant="primary" className="datePickerWithDropdown" id="dropdown-basic" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={onTodayClick} >Today</Dropdown.Item>
                                        <Dropdown.Item onClick={onLast7DaysClick}>Last 7 days</Dropdown.Item>
                                        <Dropdown.Item onClick={onLast30DaysClick}>Last 30 days</Dropdown.Item>
                                        <Dropdown.Item onClick={onLastMonthClick}>This month</Dropdown.Item>
                                        <Dropdown.Item onClick={onLastYearClick}>This year</Dropdown.Item>
                                        <Dropdown.Item onClick={() => { onAddDayClick(1) }}>+ day</Dropdown.Item>
                                        <Dropdown.Item onClick={() => { onAddDayClick(-1) }}>- day</Dropdown.Item>
                                        <Dropdown.Item onClick={() => { onAddMonthClick(1) }}>+ month</Dropdown.Item>
                                        <Dropdown.Item onClick={() => { onAddMonthClick(-1) }}>- month</Dropdown.Item>

                                    </Dropdown.Menu>
                                </Dropdown>


                            </div>
                            <div className="col-auto mr-2 mb-2" style={{ minWidth: "220px" }}>
                                <DwsimProDialogTypeFilter
                                    placeholder="Dialog types"
                                    values={includeDialogTypes}
                                    onChange={(values) => { setIncludeDialogTypes(values?.map(x => +x.value)); }} />
                            </div>
                            <div className="row">
                                <div className="col-auto pr-2" style={{ minWidth: "400px" }}>
                                    <UserTagFilter
                                        icon="fas fa-check"
                                        iconColor="green"
                                        logicalOperator={includeOperator}
                                        values={includeUserTags}
                                        className="mb-2"
                                        placeholder={"Include tags"}
                                        onOperatorChange={(operator) => { setIncludeOperator(operator); }}
                                        onChange={(newValues) => {
                                            const values: number[] | undefined = newValues !== undefined && newValues !== null ? newValues.map(x => +x.value) : undefined;
                                            setIncludeUsersTags(values);
                                        }}
                                    />
                                </div>
                                <div className="col-auto pl-0 pr-2" style={{ minWidth: "400px" }}>
                                    <UserTagFilter
                                        icon="fas fa-times"
                                        iconColor="red"
                                        logicalOperator={excludeOperator}
                                        values={excludeUserTags}
                                        className="mb-2"
                                        placeholder={"Exclude tags"}
                                        onOperatorChange={(operator) => { setExcludeOperator(operator); }}
                                        onChange={(newValues) => {
                                            const values: number[] | undefined = newValues !== undefined && newValues !== null ? newValues.map(x => +x.value) : undefined;
                                            setExcludeUsersTags(values);
                                        }}
                                    />
                                </div>
                            </div>


                            <div className="col-auto ml-2">
                                <button type="submit" className="btn btn-primary mb-2 mr-2" >Search</button>
                                <button type="button" className="btn btn-default mb-2" style={{ marginRight: '50px' }} onClick={() => resetForm()}> <i className="fas fa-eraser" /> </button>
                            </div>
                        </div>
                    </form>

                    <div>
                        <select className="form-control form-select" value={recordsPerPage} onChange={(event) => setPagination(s => ({ ...s, recordsPerPage: +event.target.value }))}>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                            <option value="500">500</option>
                            <option value="10000">1000</option>
                        </select>
                    </div>

                </div>
            </Card>
            <Card >
                <Card.Body>

                    <div className="">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th className={"sortable " + getSortValue("Username")}
                                        onClick={() => { onColumnClick("Username") }}>User</th>
                                    <th className={"text-center sortable " + getSortValue("ScreenshotsCount")}
                                        onClick={() => { onColumnClick("ScreenshotsCount") }} style={{ width: "120px" }}>Screenshots</th>
                                    <th className={"text-center sortable " + getSortValue("FeedbackScore")}
                                        onClick={() => { onColumnClick("FeedbackScore") }} style={{ width: "120px" }}>Feedback</th>
                                    <th className={"text-center sortable " + getSortValue("Duration")}
                                        onClick={() => { onColumnClick("Duration") }} style={{ width: "120px" }}>Duration</th>
                                    <th className={"text-center sortable " + getSortValue("StartedAtUtc")}
                                        onClick={() => { onColumnClick("StartedAtUtc") }} style={{ width: "200px" }} >Started at</th>
                                    <th className={"text-center sortable " + getSortValue("EndedAtUtc")}
                                        onClick={() => { onColumnClick("EndedAtUtc") }} style={{ width: "200px" }}>Ended at</th>
                                    <th>Dialogs shown</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>

                                {sessions.map((item) =>
                                (<tr key={item.id} >
                                    <td className="">
                                        {!!item.user && <UserSlimDisplay user={item.user} showDetailsOnClick />}
                                        {!item.user && <span>{item.windowsUsername}</span>}
                                    </td>
                                    <td className={`align-middle text-center`}>
                                        {!!item.screenshotsCount ? <a href={getScreenshotsLink(item)}>{item.screenshotsCount}</a> : "-"}
                                    </td>
                                    <td className={`align-middle text-center`}>
                                        {!!item && !!item.feedbackScore && item.feedbackScore !== null &&
                                            <span className={`d-flex flex-column justify-content-center align-items-center ${getTextBasedOnFeedbackScore(item.feedbackScore, 'text-danger', 'text-warning', 'text-success')}`}>
                                                <span style={{ fontSize: '1.5em', lineHeight: 1, fontWeight: 'bold' }}>{item.feedbackScore}</span>
                                                <small style={{ lineHeight: 1 }}>{getTextBasedOnFeedbackScore(item.feedbackScore, 'Detractor', 'Passive', 'Promoter')}</small>
                                            </span>
                                        }
                                    </td>
                                    <td className={`align-middle text-center`}>
                                        {item.duration}
                                    </td>
                                    <td className="align-middle text-center">
                                        <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={UtcTimePopover}>
                                            <span><DateTimeDisplay date={item.startedAtUtc!} /></span>
                                        </OverlayTrigger></td>
                                    <td className="align-middle text-center">
                                        <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={UtcTimePopover}>
                                            <span><DateTimeDisplay date={item.endedAtUtc!} /></span>
                                        </OverlayTrigger>
                                    </td>
                                    <td className="align-middle">
                                        <div className="d-flex" style={{ gap: "5px" }}>
                                            {!!item.dialogs && item.dialogs.map((dialogType) => (<DwsimProDialogTypeDisplay value={dialogType} />))}
                                        </div>

                                    </td>
                                    <td className="align-middle">
                                        <a href={getGraylogLink(item)} target="_blank">Logs</a>
                                    </td>
                                </tr>))
                                }

                                {!!isLoading &&
                                    <tr>
                                        <td colSpan={6} className="text-center">Loading...</td>
                                    </tr>
                                }


                            </tbody>
                        </table>

                        {totalPages > 1 &&
                            <div className="d-flex align-items-center">
                                <ReactPaginate
                                    previousLabel={'previous'}
                                    nextLabel={'next'}
                                    breakLabel={'...'}
                                    breakClassName={'break-me page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    pageCount={totalPages}
                                    marginPagesDisplayed={4}
                                    pageRangeDisplayed={10}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'page-link'}
                                    forcePage={currentPage - 1}
                                    onPageChange={(page: any) => {
                                        console.log("Selected page:", page);
                                        setPagination(s => ({ ...s, currentPage: page.selected + 1 }));
                                        document.body.scrollTop = 0; // For Safari
                                        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                                    }}
                                    containerClassName={'pagination mb-0'}
                                    activeClassName={'active'}
                                />

                            </div>
                        }
                    </div>



                </Card.Body>
            </Card>
        </ContentWrapper></div>;
}